import { IAgencyGridRow } from '@/Interfaces/Agency.interface';
import BuildingIcon from '@/components/Icons/BuildingIcon';
import { Chip, styled } from '@mui/material';
import { GridRenderCellParams } from '@mui/x-data-grid-pro';

const AgencyChip = styled(Chip)(({ theme }) => ({
  maxHeight: '29px',
  borderRadius: '32px',
  width: '32px',
  background: '#1B43321F',
  '& .building-icon': {
    margin: 0,
    color: theme.palette.success.dark,
  },
  '& span': {
    display: 'none',
  },
}));

const AgencyNameCell = ({ value }: GridRenderCellParams<IAgencyGridRow>) => {
  return (
    <div className='overflow-hidden flex gap-2 align-middle text-center'>
      <AgencyChip icon={<BuildingIcon />} variant='outlined' />
      <span className='mt-1'>{value}</span>
    </div>
  );
};

export default AgencyNameCell;
